// $ = $Query.noConflict(); 

$(window).on('load', function()
{
    
    

});

$(function(e) {

    $('.header-block').on('click', function () {
        $(this).toggleClass( "active");
        $(this).siblings('.paragraph-block').slideToggle();
    });


    $("#covidNotice").modal('show');

    $('.owl-carousel.thankYou').owlCarousel({
        loop:true,
        margin:10,
        nav:true,
        mouseDrag: false,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:1
            },
            1000:{
                items:1
            }
        }
    });
    
    var url = $(location).attr('href'),
        parts = url.split("/"),
        last_part = parts[parts.length-2],
        bookCookie = Cookies.get('modalVisited');
        
    if(last_part == 'book-appointment' && bookCookie != 'yes') {
        $(document).on('click', '.navbar-nav li', function(e) {
            var mainNavItems = $('#primary-menu li');
                navItemHref = $(this).find('.nav-link').attr('href');
                console.log(navItemHref);
            var navArray = [];
            
            $('#bookAppointment .nextPage').attr('href', navItemHref);

            mainNavItems.each( function() {
                var navigationItem = $(this).find('.nav-link').html();
                
                if( navigationItem !== 'Book an appointment' && navigationItem !== 'LEASE NOW' && navigationItem !== 'Resident Portal') {
                    navArray.push(navigationItem);
                }
            });
            console.log(navArray);
            var navItem = $(this).find('.nav-link').html();
            if(last_part == 'book-appointment' && $.inArray(navItem, navArray) != -1) {
                e.preventDefault();
                console.log('show modal');
                $('.modal').modal('show');
            }  
        });
    }

    $('#bookAppointment .nextPage').click(function() {
        Cookies.set('modalVisited', 'yes', { expires: 1 });
    });

    // floor plans - twelve blocks 3
    $('.floor-plans-trigger:first').addClass('active');
    $('.floor-plans-trigger').on('click', function() {
        var layoutID = $(this).attr('id');
        console.log( '#layout-' + layoutID );
        $('.floor-plans-trigger').removeClass( "active");
        $(this).addClass( "active");
        $('.layout-image').hide();
        $( '#layout-' + layoutID ).show();
    });



    // Header 17
    $('.tgl-cl').on('click', function() {
        $('body .h17-main-nav').toggleClass("show");
    });
    $('.h17-main-nav').perfectScrollbar();


    // SLIDESHOWS

    //== Slider 1 ==//
    $('#slider1').bsTouchSlider();
    $("#slider1 .carousel .carousel-inner").swipe({
        swipeLeft: function (event, direction, distance, duration, fingerCount) {
            this.parent().carousel('next');
        }
        , swipeRight: function () {
            this.parent().carousel('prev');
        }
        , threshold: 0
    });

    $('#slider2').bsTouchSlider();
    $("#slider2 .carousel .carousel-inner").swipe({
        swipeLeft: function (event, direction, distance, duration, fingerCount) {
            this.parent().carousel('next');
        }
        , swipeRight: function () {
            this.parent().carousel('prev');
        }
        , threshold: 0
    });

    $('.feature-35-owl').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        // nav: true,
        dots: true,
        responsive: {
            0: {
                items: 1,
                nav: false
            },
            1000: {
                items: 2,
                nav: false
            },
            1650: {
                items: 3,
                nav: false,
                loop: false
            }
        }
    });

    $('.owl-carousel.explore').owlCarousel({
        loop:false,
        margin:10,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:5
            }
        }
    });


    $(function(){
        // Check the initial Poistion of the Sticky Header
        var stickyHeaderTop = $('.header1.front-page').offset().top;
        $(window).scroll(function(){
            if( $(window).scrollTop() > stickyHeaderTop ) {
                $('.nav-buffer').show();
                $('.header1.front-page').css({position: 'fixed', top: '0px'});
                

            } else {
                $('.header1.front-page').css({position: 'relative'});
                $('.nav-buffer').hide();
            }
        });
    });



    // if ( e.target.is( "#book-appointment-anchor" ) ) {
    //     var offset = $(':target').offset();
    //     var scrollto = offset.top - 50; // minus fixed header height
    //     $('html, body').animate({scrollTop:scrollto}, 0)
    // }

});

